import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const BodyStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      minHeight: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "20px",
      padding: "0",
      gap: "16px",
    },
  }),
);
